// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pg-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;
  padding: 12px 4px 4px;
  box-sizing: border-box;
}

.pg-meta {
  margin: 0;
  font-size: 0.8125rem;
  color: #64748b;
  line-height: 1.4;
}

.pg-meta strong {
  color: #0f172a;
  font-weight: 650;
}

.pg-meta-pages {
  color: #94a3b8;
}

.pg-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pg-btn {
  appearance: none;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #334155;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1;
  height: 36px;
  min-width: 34px;
  padding: 0 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.pg-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #0f172a;
}

.pg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.pg-nav {
  color: #475569;
}

@media (max-width: 640px) {
  .pg-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .pg-controls {
    justify-content: space-between;
  }

  .pg-btn {
    flex: 1 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/Pagination.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,SAAO;EACT;AACF","sourcesContent":[".pg-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  padding: 12px 4px 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.pg-meta {\r\n  margin: 0;\r\n  font-size: 0.8125rem;\r\n  color: #64748b;\r\n  line-height: 1.4;\r\n}\r\n\r\n.pg-meta strong {\r\n  color: #0f172a;\r\n  font-weight: 650;\r\n}\r\n\r\n.pg-meta-pages {\r\n  color: #94a3b8;\r\n}\r\n\r\n.pg-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.pg-btn {\r\n  appearance: none;\r\n  border: 1px solid #e2e8f0;\r\n  background: #fff;\r\n  color: #334155;\r\n  font-size: 0.8125rem;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  height: 36px;\r\n  min-width: 34px;\r\n  padding: 0 14px;\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\r\n}\r\n\r\n.pg-btn:hover:not(:disabled) {\r\n  background: #f8fafc;\r\n  border-color: #cbd5e1;\r\n  color: #0f172a;\r\n}\r\n\r\n.pg-btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pg-nav {\r\n  color: #475569;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .pg-bar {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .pg-controls {\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .pg-btn {\r\n    flex: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
